const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Medication/AdministrationPoint/AdministrationPointList.tsx';
import { css } from '@emotion/css';
import { AdministrationPoint, IAdministrationPoint } from './AdministrationPoint';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';

interface IAdministrationPointListProps {
    administrationPoints: IAdministrationPoint[];
}

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            root: css`
                flex: 0 0 auto;
                flex-wrap: wrap;
                padding: 0;
                display: grid;
                grid-gap: 0.25rem;
                grid-template-columns: repeat(auto-fit, minmax(4rem, 1fr));
            `,
        }),
        [theme]
    );
}

/**
 * Functional React component
 */
export const AdministrationPointList = (props: IAdministrationPointListProps) => {
    const classes = useCSSClasses();
    return (
        <div className={classes.root}>
            {props.administrationPoints.map((administrationPoint: IAdministrationPoint) => {
                const { time, schemaLabel } = administrationPoint;
                return <AdministrationPoint key={`${time} ${schemaLabel}`} {...administrationPoint} />;
            })}
        </div>
    );
};
